var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__schedule-24px",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-1{fill:#6c7ef2}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1544",
    d: "M10.325 2a8.333 8.333 0 1 0 8.342 8.333A8.329 8.329 0 0 0 10.325 2zm.008 15A6.667 6.667 0 1 1 17 10.333 6.665 6.665 0 0 1 10.333 17z",
    className: "prefix__cls-1",
    "data-name": "Path 1544",
    transform: "translate(-.333 -.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1545",
    fill: "none",
    d: "M0 0h20v20H0z",
    "data-name": "Path 1545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1546",
    d: "M12.25 7H11v5l4.375 2.625L16 13.6l-3.75-2.225z",
    className: "prefix__cls-1",
    "data-name": "Path 1546",
    transform: "translate(-1.833 -1.167)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.9b39a98f91de81611b47eab82f4ebad1.svg";
export { ForwardRef as ReactComponent };